import{ FC } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import type { RouteProps } from 'react-router-dom';
import config from 'config';

import { LoginPage, MagicLoginPage, CreatePasswordPage, ResetPasswordPage, RegistrationPage } from 'modules/auth';
import { MagicLinkPage, GuestVerifyPage } from 'modules/guest';

export const routes: Array<RouteProps> = [
    {
        path: config.routes.login,
        exact: true,
        render: () => <LoginPage />,
    },
    {
        path: config.routes.magicLogin,
        exact: true,
        render: () => <MagicLoginPage />,
    },
    {
        path: config.routes.registration,
        exact: true,
        render: () => <RegistrationPage />,
    },
    {
        path: config.routes.createPassword,
        exact: true,
        render: () => <CreatePasswordPage />,
    },
    {
        path: config.routes.forgotPassword,
        exact: true,
        render: () => <ResetPasswordPage />,
    },
    {
        path: config.routes.guestLogin,
        exact: true,
        render: () => <MagicLinkPage />,
    },
    {
        path: config.routes.guestVerify,
        exact: true,
        render: () => <GuestVerifyPage />,
    },
    {
        render: ({ location }) => <Redirect to={{ pathname: config.routes.login, state: { from: location } }} />,
    },
];

export interface RoutesProps {}

const Routes: FC<RoutesProps> = () => (
    <Switch>
        {routes.map((route, index) => (
            <Route key={String(route.path ?? index)} {...route} />
        ))}
    </Switch>
);

export default Routes;
